import 'typeface-roboto';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import store from './store';
import { LocalizationProvider } from './common/components/LocalizationProvider';
import ErrorHandler from './common/components/ErrorHandler';
import { ThemeModeProvider } from './common/theme/ThemeMode';
import Navigation from './Navigation';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import UpdatePrompt, { UPDATE_READY } from './shell/UpdatePrompt';
import InstallPrompt from './shell/InstallPrompt';
import NativeInterface from './common/components/NativeInterface';
import ServerProvider from './ServerProvider';
import brand from './shell/brand';

// The product this address sells, named in the tab before the first screen is drawn - so the
// notification count, which puts "(2)" in front of whatever is there, has the right name to put it
// in front of.
document.title = brand.name;
if (brand.favicon) {
  const icon = document.querySelector('link[rel="icon"]');
  if (icon) icon.href = brand.favicon;
  const touch = document.querySelector('link[rel="apple-touch-icon"]');
  if (touch && brand.touchIcon) touch.href = brand.touchIcon;
  const title = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (title) title.content = brand.name;
}

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <LocalizationProvider>
      <StyledEngineProvider injectFirst>
        <ThemeModeProvider>
          <CssBaseline />
          <ServerProvider>
            <BrowserRouter>
              <Navigation />
            </BrowserRouter>
          </ServerProvider>
          <UpdatePrompt />
          <InstallPrompt />
          <ErrorHandler />
          <NativeInterface />
        </ThemeModeProvider>
      </StyledEngineProvider>
    </LocalizationProvider>
  </Provider>,
);

// Without an onUpdate handler a new build installs and then waits indefinitely, so a
// deploy never reaches a browser that already has the app open.
serviceWorkerRegistration.register({
  onUpdate: (registration) => window.dispatchEvent(new CustomEvent(UPDATE_READY, { detail: registration })),
});
